import 'twin.macro'

import { Fragment, ReactNode } from 'react'
import Slider from 'react-input-slider'
import { TwStyle } from 'twin.macro'

type LandingSliderProps = {
  value: number
  step?: number
  max: number
  min: number
  twStyle?: TwStyle
  disabled?: boolean
  renderMinText?: (min: number) => ReactNode
  renderMaxText?: (max: number) => ReactNode
  onChange: (value: number) => void
}

const sliderInputStyles = {
  track: {
    backgroundColor: 'var(--bg-track)',
    width: '100%',
    marginInline: 'auto',
    height: '1px',
    display: 'block',
    borderRadius: '40px'
  },
  active: {
    backgroundColor: 'var(--text-landing-green)',
    height: '3.33px'
  },
  thumb: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    boxShadow: '0px 2px 2px rgba(114, 191, 68, 0.2)',
    border: '3px solid var(--text-landing-green)',
    background: 'var(--bg-landing-toggle-button)'
  }
}

const LandingSlider = ({
  max,
  min,
  onChange,
  value,
  disabled,
  step,
  renderMaxText,
  renderMinText
}: LandingSliderProps) => {
  const handleSliderChange = ({ x: value }: { x: number }) => {
    onChange(value)
  }

  return (
    <Fragment>
      <Slider
        tw='mt-2'
        axis='x'
        xmin={min}
        xmax={max}
        xstep={step}
        x={value}
        disabled={disabled}
        styles={sliderInputStyles}
        onChange={handleSliderChange}
      />
      <div tw='flex items-center mt-1'>
        {renderMinText && (
          <span tw='text-[var(--text-landing-subtitle)] text-[12px] leading-[18px] mt-4 -ml-2'>
            {renderMinText(min)}
          </span>
        )}
        {renderMaxText && (
          <span tw='text-[var(--text-landing-subtitle)] text-[12px] leading-[18px]  mt-4 ml-auto'>
            {renderMaxText(max)}
          </span>
        )}
      </div>
    </Fragment>
  )
}

export default LandingSlider
